import { Col, PageWrapper, Row } from '@qonsoll/react-design'

import { HeaderBreadcrumbs } from 'components'
import { RewardAdvancedForm } from 'domains/Reward/components'
import { useTranslations } from 'contexts/Translation'
import { useRewardBaseActions } from 'domains/Reward/hooks'

const RewardCreatePage = (props) => {
  /* Getting translations instance */
  const { t } = useTranslations()
  /* Getting base actions */
  const { onBack } = useRewardBaseActions()

  /* Configuring page header */
  const headingProps = {
    title: t('Reward create'),
    titleSize: 3,
    marginBottom: 3,
    textAlign: 'left'
  }

  const initialCreateFormData = { reward: { isBlocked: false } }

  return (
    <PageWrapper
      onBack={onBack}
      breadcrumbs={<HeaderBreadcrumbs />}
      headingProps={headingProps}>
      <Row noGutters>
        <Col cw={[12, 12, 10, 8, 7]}>
          <RewardAdvancedForm initialCreateData={initialCreateFormData} />
        </Col>
      </Row>
    </PageWrapper>
  )
}

export default RewardCreatePage
